<template>
  <div id="app">

    <FetchArea />
    <HeaderArea />
    <MessageArea />
    <MenuArea />

    <keep-alive include="auth.dashboard">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import FetchArea from '@/components/FetchArea.vue';
import MessageArea from '@/components/MessageArea.vue';
import HeaderArea from '@/components/HeaderArea.vue';
import MenuArea from '@/components/MenuArea.vue';

export default {
  name: 'Home',
  components: {
    FetchArea,
    MessageArea,
    HeaderArea,
    MenuArea,
  },
  created() {
    this.initialLoad();
  },
  methods: {
    initialLoad() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user) return;

      this.$store.commit('authorized', user);

      const properties = JSON.parse(localStorage.getItem('properties'));
      if (!properties) return;

      this.$store.commit('properties', properties);

      const cities = JSON.parse(localStorage.getItem('cities'));
      if (!cities) return;

      this.$store.commit('updateCities', cities);

      const states = JSON.parse(localStorage.getItem('states'));
      if (!states) return;

      this.$store.commit('updateStates', states);

      const neighborhoods = JSON.parse(localStorage.getItem('neighborhoods'));
      if (!neighborhoods) return;

      this.$store.commit('updateNeighborhoods', neighborhoods);
    },
    logout() {
      this.$store.dispatch('logout');
    },
  },
};
</script>

<style>
  @import "assets/style.css";
  #nav a{
    padding: 5px;
  }
</style>
